import { FULL_HD, HD } from '@bedrock-rdk/constants';
import { FONT, FONT_TYPE } from '@tornado-rdk/typography';
import { ICON_POSITION } from '../../../utils/templates';
import Icon from '../../../icon/icon.component';
import { Badge } from '../../../badge/badge.component';

export const DISPLAY_ICONS = true;

export const DISPLAY_EXTRA_TITLE = true;

export const DISPLAY_DETAILS = false;

export const TITLE_FONT_TYPE = FONT_TYPE.MAIN;

export const TITLE_FONT_NAME = FONT.OTTAWA_3;

export const EXTRA_HIGHLIGHT_FONT_NAME = FONT.BERLIN_1;

export const EXTRA_HIGHLIGHT_FONT_TYPE = FONT_TYPE.MAIN;

export const ICONS = {
  [ICON_POSITION.TOP_RIGHT]: 4,
  [ICON_POSITION.BOTTOM_RIGHT]: 1,
  [ICON_POSITION.CENTER]: 3,
};

export const SIDE_GLASS_ICONS = {
  [ICON_POSITION.TOP_LEFT]: 3,
  [ICON_POSITION.TOP_RIGHT]: 4,
  [ICON_POSITION.BOTTOM_RIGHT]: 1,
  [ICON_POSITION.CENTER]: 3,
};

export const ICONS_TYPES = {
  [ICON_POSITION.TOP_LEFT]: Icon,
  [ICON_POSITION.TOP_RIGHT]: Badge,
  [ICON_POSITION.BOTTOM_RIGHT]: Icon,
  [ICON_POSITION.CENTER]: Icon,
};

export const ITEMS_BY_BREAKPOINTS = {
  general: {
    [HD]: 2,
    [FULL_HD]: 2,
  },
  search: {
    [HD]: 1,
    [FULL_HD]: 1,
  },
};
